import { Box, Typography, useTheme } from '@mui/material';

export const ProductThumbnail = ({
  thumbnailUrl,
  itemNumber,
}: {
  thumbnailUrl?: string | null;
  itemNumber?: string | null;
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'relative',
        width: 104,
        height: 104,
        flexShrink: 0,
        borderRadius: 2,
        overflow: 'hidden',
        border: '1px solid',
        borderColor: theme.palette.custom.gray[300],
        backgroundColor: theme.palette.common.white,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundColor: thumbnailUrl ? theme.palette.common.white : theme.palette.custom.gray[200],
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundImage: thumbnailUrl ? `url(${thumbnailUrl})` : 'none',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          right: 0,
          bottom: 0,
          left: 0,
          height: 26,
          borderTop: '1px solid',
          borderColor: theme.palette.custom.gray[300],
          backgroundColor: !thumbnailUrl ? theme.palette.common.white : theme.palette.custom.gray[200],
        }}
      />
      {itemNumber && (
        <Box sx={{ position: 'absolute', left: 6, bottom: 3, maxWidth: 'calc(100% - 12px)' }}>
          <Typography variant="textXS"
            sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {itemNumber}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ProductThumbnail;
